
import { PDFDocument } from "pdf-lib";

export const isImageUrl = (url) =>
  /\.(?:avif|gif|jpe?g|png|svg|webp)(?:[?#].*)?$/i.test(String(url || ""));

export const isPdfUrl = (url) =>
  /\.pdf(?:[?#].*)?$/i.test(String(url || ""));

const isJpeg = (file) =>
  ["image/jpeg", "image/jpg"].includes(file?.type) ||
  /\.jpe?g$/i.test(file?.name || "");

const isPng = (file) =>
  file?.type === "image/png" || /\.png$/i.test(file?.name || "");

export const convertInvoiceImagesToPdf = async (imageFiles, fileName) => {
  const pdfDocument = await PDFDocument.create();

  for (const imageFile of imageFiles) {
    const imageBytes = await imageFile.arrayBuffer();
    let embeddedImage;

    if (isJpeg(imageFile)) {
      embeddedImage = await pdfDocument.embedJpg(imageBytes);
    } else if (isPng(imageFile)) {
      embeddedImage = await pdfDocument.embedPng(imageBytes);
    } else {
      throw new Error("Only JPEG and PNG invoice images are supported");
    }

    const page = pdfDocument.addPage([
      embeddedImage.width,
      embeddedImage.height,
    ]);
    page.drawImage(embeddedImage, {
      x: 0,
      y: 0,
      width: embeddedImage.width,
      height: embeddedImage.height,
    });
  }

  const pdfBytes = await pdfDocument.save();
  const normalizedFileName = (fileName || "invoice")
    .trim()
    .replace(/[^a-zA-Z0-9_-]+/g, "-");

  return new File([pdfBytes], `${normalizedFileName || "invoice"}.pdf`, {
    type: "application/pdf",
  });
};
